import React, { useEffect } from "react";
import { connect } from "react-redux";
import { debug } from "../../utils";
import * as validationService from "../add-device-modal/validationService";

function ApiPasswordField({ value, onChange, anotherSectionActive, passwordChanged, onChangeApiPasswordClick, error, disabled }) {

    // useEffect(() => {
    //     validationService.validateNotEmpty(value, 'apiPassword');
    //     return () => validationService.cleanValidation('apiPassword');
    // }, [value])

    useEffect(() => {
        if (anotherSectionActive) {
            validationService.cleanValidation('apiPassword');
        } else {
            validationService.validateNotEmpty(value, 'apiPassword');
        }
        return () => validationService.cleanValidation('apiPassword');
    }, [value, anotherSectionActive])

    return (
        <div className="form-group">
            <div className="oct_form-group oct_form-sm">
                <label htmlFor="apipassword">Password <span className="modal-v2-required-mark">*</span></label>
                <div className="modal-v2-field-action-row">
                    <input className={`form-control oct_field ${error && 'border-danger'}`}
                        id="apipassword"
                        type="password"
                        value={value}
                        disabled={!passwordChanged}
                        onChange={disabled ? null : event => onChange(event.target.value)} />
                    {!passwordChanged
                        && value
                        && <button type="button"
                            className="modal-v2-btn modal-v2-btn-primary modal-v2-inline-change-btn"
                            onClick={disabled ? null : () => onChangeApiPasswordClick()}>
                            Change
                        </button>}
                </div>
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("apiPasswordField mapStateToProps", state);
    const validation = state.validation;
    return {
        error: validation.apiPassword,
    }
}

export default connect(mapStateToProps)(ApiPasswordField);
